export enum SearchModeEnum {
    contact = 'CONTACT',
    outlet = 'OUTLET'
}


export const searchModeEnumToTabIndexMap = new Map([
    [0, SearchModeEnum.contact],
    [1, SearchModeEnum.outlet]
]);


export const tabIndexToSearchModeEnumMap = new Map([
    [SearchModeEnum.contact, 0],
    [SearchModeEnum.outlet, 1]
]);
